export class UserModel {
    username: string | undefined | null = null;
    expritesIn : number;
    expirateDate : Date;
}